export const DEMONSTRATE_VIDEOS_URLS = [
  "https://youtu.be/pEbd9bzvpKY",
  "https://youtu.be/DSmp0S_A1AA",
  "https://youtu.be/MdoOz7d_LJs", 
];
